import { useEffect } from 'react'

import { useLocation, useNavigate, } from 'react-router-dom';

const PaymentRequestPortal = () => {
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        const searchParams = location.search; // includes the ?INV=... part
        navigate(`/paymentgateway${searchParams}`, { replace: true });
    }, [location, navigate]);
    return null
}

export default PaymentRequestPortal
